import { render, staticRenderFns } from "./related-prescription-popver.vue?vue&type=template&id=dfe3a3cc&scoped=true&"
import script from "./related-prescription-popver.vue?vue&type=script&lang=js&"
export * from "./related-prescription-popver.vue?vue&type=script&lang=js&"
import style0 from "./related-prescription-popver.vue?vue&type=style&index=0&id=dfe3a3cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe3a3cc",
  null
  
)

export default component.exports